import React, { FunctionComponent } from "react";
import BottomMenu from "../../menus/bottomMenu";
import "./style.scss";

const MainFooter: FunctionComponent = () => {
    return <div className="MainFooter">
        <div className="content">
            <BottomMenu />
            <div className="rights">“2022 Copyright Spark Agency FZE”. All rights reserved.</div>
        </div>
    </div>
}

export default MainFooter;